import Layout from "@/layout";

const storesManageRouter = {
  path: "/storesManage",
  component: Layout,
  redirect: "/storesManage",
  name: "storesManage",
  meta: {
    title: "门店管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "storeConfiguration",
      component: () =>
        import("@/views/storesManage/storeConfiguration/index.vue"),
      name: "shop",
      meta: { title: "门店配置", icon: "" },
      alwaysShow: true
    }
  ]
};

export default storesManageRouter;
